import { Button } from "@thrivetribe/gloji.ui.atoms.button";
import { CustomModal, ModalContent, ModalTitle } from "../../CustomModal";
import useUserId from "../../../hooks/useUserId";
import "./CloseSignUpModal.scss";

interface Props {
  showModal: boolean;
  onClose(): void;
}

export function CloseSignUpModal({ showModal, onClose }: Readonly<Props>) {
  const [userId] = useUserId();

  const handleExitProgress = () => {
    window.location.href = !userId ? "https://www.gloji.co.uk" : "/";
  };

  return (
    <CustomModal
      open={showModal}
      onClose={onClose}
      id="closeSignUpModal"
      modalTitleId="closeSignUpModalTitle"
      modalDescriptionId="closeSignUpModalDescription"
      aria-labelledby={"closeSignUpModalTitle"}
    >
      <ModalContent id="closeSignUpModalContent">
        <ModalTitle id="closeSignUpModalTitle">Are you sure?</ModalTitle>
        <p className="modal-text" id="closeSignUpModalDescription">
          If you leave now, we won't be able to save where you're up to. You'll need to start over.
        </p>
        <div id="closeSignUpModalButtons">
          <Button className="modal-button" variant="contained" color="secondary" onClick={onClose}>
            No, Don't Close
          </Button>
          <Button className="modal-button" variant="contained" color="primary" onClick={handleExitProgress}>
            Yes, Close
          </Button>
        </div>
      </ModalContent>
    </CustomModal>
  );
}
